import { BandeauHorsLigne } from './BandeauHorsLigne.jsx';
import { BanniereMiseAJourConnectee } from './BanniereMiseAJour.jsx';

/**
 * Les deux bandeaux de l'application installée, posés en haut du cadre :
 * hors ligne, et nouvelle version disponible.
 *
 * @returns {JSX.Element} les bandeaux, vides quand tout va bien
 */
export function BandeauxPwa() {
  return (
    <div
      className="no-print"
      style={{ position: 'absolute', left: 0, right: 0, top: 0, zIndex: 55 }}
    >
      <BandeauHorsLigne />
      <BanniereMiseAJourConnectee />
    </div>
  );
}
